import { Vector3 as r, Matrix4 as m } from "three";
import { getMatrix as c } from "../geometry-utils/three/index9.js";
import { getLineage as w } from "@project-rouge/rg-core";
const s = new r(), x = new r(), o = new r(), l = new r(), e = new m(), _ = new m();
function M({
  obj: p,
  type: f,
  query: y,
  pivot: g,
  out: i = new r()
}) {
  const t = w({ obj: p, type: f, query: y });
  if (!t.length)
    return i.setScalar(NaN);
  const u = t[0], a = t[t.length - 1];
  o.fromArray(a.size), l.fromArray(a.anchor), c(u, e);
  for (let n = 1; n < t.length; n++)
    e.multiply(c(t[n], _));
  return i.setScalar(0).sub(s.copy(o).multiply(l)).add(s.copy(o).multiply(x.fromArray(g))).applyMatrix4(e);
}
export {
  M as queryPivot
};
//# sourceMappingURL=index25.js.map
